/*!
VueLayers
Web map Vue components with the power of OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.10.25
@license MIT
@copyright (c) 2017-2018, Vladimir Vershinin <ghettovoice@gmail.com>
*/
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function log() {
  var _console;

  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  (_console = console).log.apply(_console, ['[VueLayers]'].concat(args));
}

function warn(msg) {
  var _console2;

  for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  (_console2 = console).warn.apply(_console2, ['[VueLayers] WARNING: ' + msg].concat(args));
}

function error(msg) {
  var _console3;

  for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    args[_key3 - 1] = arguments[_key3];
  }

  (_console3 = console).error.apply(_console3, ['[VueLayers] ERROR: ' + msg].concat(args));
}

exports.log = log;
exports.warn = warn;
exports.error = error;



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/lib/util/log.js
// module id = 244
// module chunks = 1